import { computed } from 'vue'

import { usePageStore } from '../../stores/page'
import { pageTypeSchema } from '../types/ad-slot-types'

export function usePageType () {
  const pageStore = usePageStore()
  return computed(() => {
    const pageType = pageStore.pageData.pageMeta.pageType
    const isContentCommerce = pageStore.pageData.metaData.isContentCommerce

    if (pageType === 'structureterm') {
      // Additional check for structureterm
      const structureTermType = pageStore.pageData.pageMeta.structureTermType
      if (structureTermType === 'structure') {
        // Map to overview page
        return 'overviewPage'
      }

      if (structureTermType === 'static') {
        // Map to static page
        return 'staticPage'
      }

      if (structureTermType === 'author') {
        // Map to author page
        return 'authorPage'
      }

      if (pageStore.pageData.metaData.adaAutoNative === true) {
        // Map to autonative page to overview page
        return 'overviewPage'
      }
    }

    if (pageType === 'article' && isContentCommerce) {
      // Map to commerce article
      return 'commerceArticle'
    }

    return pageTypeSchema.parse(pageType)
  })
}
